module.exports = __webpack_public_path__ + "img/SVG.283083b0.svg";